// ThemeContext.js
import React from 'react';

const ThemeContext = React.createContext({
  theme: 'light', // default value
  toggleTheme: () => {}
});

export default ThemeContext;
